import React from 'react';
import * as styles from './heroHeaderUrlBased.module.scss';
import { VideoPlayer } from '../videoPlayer/VideoPlayer';

interface IHeroHeaderUrlBasedProps {
  children: React.ReactNode;
  urlBased: UrlBasedImage;
}

export type UrlBasedImage = {
  _key: string;
  url: string;
  alt?: string;
  type?: string;
};

enum MediaEnum {
  image = 'Image',
  video = 'Video',
}

export const HeroHeaderUrlBased = ({ children, urlBased }: IHeroHeaderUrlBasedProps) => (
  <div className={styles.wrapper}>
    <div className={styles.mediaWrapper}>
      {urlBased?.type === MediaEnum.image && (
        <img key={urlBased?._key} src={urlBased?.url} alt={urlBased?.alt} loading="eager" />
      )}
      {urlBased?.type === MediaEnum.video && <VideoPlayer video={urlBased?.url} />}
      <div className={styles.shadow} />
    </div>
    {children}
  </div>
);
